export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7193.fef627ff.jpg";